export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9898.784120ed.jpg";